export default "__VITE_ASSET__DpwDetOY__"